import { useEffect, useState } from 'react';
import { CHANNELS } from '../../lib/marketing';

export default function UploadForm({ onSubmit, onCancel, initialFile }) {
  const [channel, setChannel] = useState(CHANNELS[0]);
  const [caption, setCaption] = useState('');
  const [file, setFile] = useState(initialFile || null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // A file dropped on the library opens this form pre-filled, so the drop
  // isn't silently discarded when the form mounts.
  useEffect(() => {
    if (initialFile) setFile(initialFile);
  }, [initialFile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!file) {
      setError('Choose an image to upload.');
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit({ channel, caption: caption || null }, file);
      setChannel(CHANNELS[0]);
      setCaption('');
      setFile(null);
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="marketing-form" onSubmit={handleSubmit}>
      <div className="marketing-form-grid">
        <label>
          Channel
          <select value={channel} onChange={(e) => setChannel(e.target.value)}>
            {CHANNELS.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>

        <label>
          Image
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files[0] || null)}
          />
          {file && <span className="marketing-form-filename">{file.name}</span>}
        </label>

        <label className="marketing-form-wide">
          Caption
          <textarea value={caption} onChange={(e) => setCaption(e.target.value)} rows={3} />
        </label>
      </div>

      {error && <p className="marketing-form-error">{error}</p>}

      <div className="marketing-form-actions">
        <button type="submit" disabled={submitting}>
          {submitting ? 'Uploading…' : 'Upload'}
        </button>
        <button type="button" className="marketing-form-cancel" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}
